import { observer } from "mobx-react-lite";
import useNavigateToLead from "../../hooks/useNavigateToLead";
import useOpenSelectedItem from "../../hooks/useOpenSelectedItem";
import LeadIcon from "../icons/LeadIcon";
import styles from "../InfoWithIconAndNavigation.module.css";
import LeadInfo, { ILeadInfoProps } from "./LeadInfo";

function LeadInfoWithIconAndNavigation({ id, address, ownerName, status, buildingSize, landSizeAcres, zoning, className, onClick, index }: ILeadInfoWithIconAndNavigationProps) {
    const navigateToLead = useNavigateToLead();

    const click = () => {
        onClick && onClick();
        navigateToLead(id);
    };

    useOpenSelectedItem(index, click);

    return (
        <div className={[styles.container, className].join(" ")} onClick={click}>
            <LeadIcon color={"#25479A"} className={styles.icon} />
            <LeadInfo
                address={address}
                ownerName={ownerName}
                status={status}
                buildingSize={buildingSize}
                landSizeAcres={landSizeAcres}
                zoning={zoning}
            />
        </div>
    );
}

interface ILeadInfoWithIconAndNavigationProps extends ILeadInfoProps {
    id: number;
    index?: number;
}

export default observer(LeadInfoWithIconAndNavigation);